import { ListingFilter, ListingFilterOption, Plan } from '../Types/Plans.Type';
import { County } from '../Types/Counties.Type';

export const sortPlansData = (plansList: Plan[], plansOrder: string[]): Plan[] => {
  const tempList: Plan[] = [];
  plansList.forEach((plan) => {
    if (tempList.find((find) => find.id == plan.id) == undefined) {
      tempList.push(plan);
    }
  });
  if (!plansOrder?.length) {
    return plansList;
  }

  const sortedPlansList = tempList.slice().sort((a, b) => {
    const indexA = plansOrder?.indexOf(a.id);
    const indexB = plansOrder?.indexOf(b.id);

    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return sortedPlansList;
};

export const findMatchingCounty = (counties: County[], stateAbbrev: string, countyName: string) =>
  counties.find((x) => {
    return (
      x.state?.toLowerCase() == stateAbbrev.toLowerCase() && x.countyName?.toLowerCase() === countyName.toLowerCase()
    );
  });

export const getPreSelectedFilters = (options: ListingFilterOption[]) => {
  const $selectedOptions: string[] = [];
  options
    .filter((o) => o.selected)
    ?.forEach((o) => {
      $selectedOptions.push(o.id);
    });

  return $selectedOptions;
};

export const updateSelectedFilterOptions = (selectedOptions: string[], currentOptionId: string) => {
  const $optionSelectedBefore = selectedOptions.includes(currentOptionId);
  return $optionSelectedBefore
    ? selectedOptions.filter((id) => id !== currentOptionId)
    : [...selectedOptions, currentOptionId];
};

export const updateFilterCounts = (filters: ListingFilter[], plans: Plan[]) => {
  filters.forEach((filter) => {
    filter.options.forEach((option) => {
      let count = 0;
      plans.forEach((pln) => {
        if (pln.matchFilters) {
          const useFilter = pln.filters.find((fltr) => fltr.id == filter.id);
          if (useFilter != undefined) {
            if (
              (useFilter.selection && useFilter.selection.includes(option.id)) ||
              isEntryValid(useFilter.entry, option.minimum, option.maximum)
            ) {
              count++;
            }
          }
        }
      });
      option.count = count;
    });
  });

  // Return non empty filters
  return filters.filter((f) => f.options.length > 0);
};

export const isEntryValid = (entry: number, minimum?: number, maximum?: number) => {
  if (entry >= 0) {
    if (minimum && maximum) {
      return entry >= minimum && entry <= maximum;
    } else if (minimum) {
      return entry >= minimum;
    } else if (maximum) {
      return entry <= maximum;
    }
  }

  return false;
};

export const filterByCategory = (plans: Plan[], filterCategory: ListingFilter) => {
  for (let x = 0; x < plans.length; x++) {
    const matchedFilter = plans[x].filters.find((fltr) => fltr.id == filterCategory.id && plans[x].matchFilters);
    const selectedOptions = filterCategory.options.filter((category) => category.selected);
    if (matchedFilter) {
      for (let y = 0; y < selectedOptions.length; y++) {
        if (selectedOptions[y].minimum != undefined || selectedOptions[y].maximum != undefined) {
          plans[x].matchFilters = isEntryValid(
            plans[x].filters.find((filter) => filter.id == filterCategory.id)?.entry ?? -1,
            selectedOptions[y].minimum,
            selectedOptions[y].maximum
          );
          break;
        } else if (selectedOptions[y].selected && matchedFilter.selection.includes(selectedOptions[y].id)) {
          plans[x].matchFilters = true;
          if (!filterCategory.selectMultiple) break;
        } else if (filterCategory.selectMultiple) {
          plans[x].matchFilters = false;
          break;
        }
        if (!filterCategory.selectMultiple) plans[x].matchFilters = false;
      }
    }
  }
  return plans;
};
